import { DEV_SETTINGS_STORAGE_KEY } from '../devSettings.types';

export const clearStoredDevSettings = (): void => {
  window.localStorage.removeItem(DEV_SETTINGS_STORAGE_KEY);
};
